import { render, staticRenderFns } from "./FiscalForm.vue?vue&type=template&id=3398b180&scoped=true"
import script from "./FiscalForm.vue?vue&type=script&lang=js"
export * from "./FiscalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3398b180",
  null
  
)

export default component.exports